export default (state = {}, action) => {
  switch (action.type) {
    case 'PANEL_GET_CLIENTS':
      return { ...state, clients: action.clients };
    case 'PANEL_GET_CLIENTS_SETTINGS':
      return { ...state, clientsSettings: action.clientsSettings };
    case 'PANEL_GET_CLIENTS_SEARCH':
      return { ...state, searched: action.searched };
    default:
      return state;
  }
};
